var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorPilotMechanicalEngineer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #454647;\n      }\n\n      .cls-2 {\n        fill: #7c889b;\n      }\n\n      .cls-3 {\n        fill: #474747;\n      }\n\n      .cls-4 {\n        fill: #e2e2e2;\n      }\n\n      .cls-5 {\n        fill: #fff;\n        mix-blend-mode: lighten;\n        opacity: .5;\n      }\n\n      .cls-6 {\n        fill: #898881;\n        opacity: .3;\n      }\n\n      .cls-7 {\n        fill: #7a756d;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        fill: #303030;\n      }\n\n      .cls-10 {\n        fill: #565759;\n      }\n\n      .cls-11 {\n        fill: #f7edef;\n      }\n\n      .cls-12 {\n        fill: #594f43;\n      }\n\n      .cls-13 {\n        fill: #393a3a;\n      }\n\n      .cls-14 {\n        fill: #0a0a0a;\n      }\n\n      .cls-15 {\n        fill: #565554;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mechanical_Engineer"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "702 1448 664.47 1419.35 406.57 1419.35 372 1440 387.4 1236.61 417.75 1221.12 637.26 1221.12 672.03 1236.61 702 1448"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "591.4 1335.21 612.99 1335.21 600.65 1273.52 591.4 1270.44 591.4 1335.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "464.94 1335.21 443.35 1335.21 455.69 1273.52 464.94 1270.44 464.94 1335.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "597.57 1313.62 458.78 1313.62 464.94 1270.44 591.4 1270.44 597.57 1313.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "612.99 1335.21 443.35 1335.21 458.78 1313.62 597.57 1313.62 612.99 1335.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "653.42 1419.23 705 1445 672.59 1236.48 637.93 1221"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "569.81 1313.62 548.22 1313.62 486.53 1270.44 508.12 1270.44 569.81 1313.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "418.5 1221 388.15 1236.48 363 1441 407.32 1419.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "705.2 1448.48 697.68 1452.88 665.05 1233.59 672.57 1236.82 705.2 1448.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "353.78 1450.57 362.31 1454 396.01 1233.66 387.41 1236.89 353.78 1450.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "529.69 1332.38 380.41 1375.83 347.02 1565.34 394.49 1644.23 463.67 1685.69 529.69 1701.76 596.36 1687.03 664.9 1644.23 712.37 1565.34 678.98 1375.83 529.69 1332.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "731.95 1349.42 731.95 1410.01 686.88 1440.3 634.41 1422.96 619.61 1358.67 679.48 1313.58 731.95 1349.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "327.21 1349.42 327.21 1410.01 372.28 1440.3 424.75 1422.96 439.55 1358.67 379.68 1313.58 327.21 1349.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "393.59 1685.69 353.36 1685.69 353.36 1631.38 393.59 1611.27 393.59 1685.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "825.72 1929.06 232.99 1929.06 232.99 1716 532.8 1607.25 825.72 1716 825.72 1929.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 393.59,
    y: 1603.22,
    width: 36.2,
    height: 106.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 628.92,
    y: 1603.22,
    width: 36.2,
    height: 106.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "665.12 1685.69 705.35 1685.69 705.35 1631.38 665.12 1611.27 665.12 1685.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "820.97 2127 237.03 2127 205 1723.7 311.75 1570.95 746.25 1570.95 853 1723.7 820.97 2127"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "725.15 2098.1 332.85 2098.1 302.85 1723.03 340.36 1673.03 714.5 1673.03 755.15 1723.03 725.15 2098.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "698.19 1486 529.95 1478.31 361.71 1486 361.71 1457.67 529.95 1449.98 698.19 1457.67 698.19 1486"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPilotMechanicalEngineer);
export default __webpack_public_path__ + "static/media/interior-pilot-mechanical-engineer.df07ef8bab3efa84cffc91751e7f4c99.svg";
export { ForwardRef as ReactComponent };